/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-02-25 17:59:16
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-05-13 15:03:03
 * @FilePath: /unifyxp-v2-store-portal/src/pages/ProductEditor/tools/selectors.ts
 */
import { createSelector } from '@reduxjs/toolkit';

export const getStatusValue = (reducer) => {
  return createSelector(
    (state: any) => state[reducer].hasModified,
    (state: any) => state[reducer].loaded,
    (state: any) => state[reducer].status,
    (state: any) => state[reducer].uuid,
    (state: any) => state[reducer].productType,
    (hasModified, loaded, status, uuid, productType) => {
      return { hasModified, loaded, status, uuid, productType };
    },
  );
};
export const getStateSelector = (reducer, settleData) => {
  return createSelector([(state: any) => state[reducer]], (product) => {
    return settleData(product);
  });
};

export const getLinkedSalesChannels = (reducer) => {
  return createSelector(
    (state: any) => state[reducer].linkedSalesChannels,
    (linkedSalesChannels) => {
      return linkedSalesChannels;
    },
  );
};

export const getProductNameSelector = (reducer) => {
  return createSelector(
    (state: any) => state[reducer].productInfo.name,
    (state: any) => state[reducer].loaded,
    (name, loaded) => {
      if (!loaded) {
        return '';
      } else {
        return name;
      }
    },
  );
};

export const getStockSubCollapseData = (reducer) => {
  return createSelector(
    (state: any) => state[reducer].subCollapseOpen,
    (state: any) => state[reducer].salesChannelAvailableQuantity,
    (state: any) => state[reducer].salesChannelAvailablePresaleQuantity,
    (
      subCollapseOpen,
      salesChannelAvailableQuantity,
      salesChannelAvailablePresaleQuantity,
    ) => {
      return {
        subCollapseOpen,
        salesChannelAvailableQuantity,
        salesChannelAvailablePresaleQuantity,
      };
    },
  );
};

export const getUnitsSelector = (reducer) => {
  const _tideUnits = (units) => {
    const { group, values } = units;
    return {
      [group]: values.map((i) => {
        return { label: i, value: i };
      }),
    };
  };
  const _formatUnits = (units) => {
    return Object.entries(units).map(([key, value]) => {
      return {
        label: key,
        children: value,
      };
    });
  };
  return createSelector(
    (state: any) => state[reducer].wightUnits,
    (state: any) => state[reducer].dimensionUnits,
    (wightUnits = [], dimensionUnits = []) => {
      const _w = wightUnits.reduce((pre, now) => {
        return {
          ...pre,
          ..._tideUnits(now),
        };
      }, {});
      //{Imperial:[{label,value}],Metric:[{label,value}]}
      const _d = dimensionUnits.reduce((pre, now) => {
        return {
          ...pre,
          ..._tideUnits(now),
        };
      }, {});
      return { weight: _formatUnits(_w), dimension: _formatUnits(_d) };
    },
  );
};
